/*
 * Global functions - Scale widgets and keyboard interactions
 */
/* global global, Gryphon, page_state */

// Handle keyboard interactions for checkboxes
global.handle_keyboard_checkbox = function (selector) {
  $('body').on('keydown', selector, function (e) {
    if (e.keyCode == 13 || e.keyCode == 32) {
      var self = $(this);
      // Only listen for this 'changed' event when 'keydown' event occurs
      self.one('changed', function () {
        self.focus();
      });
    }
  });
};

// Handle keyboard change events for form elements
global.on_change = function (e) {
  // Click the element, and update it's
  // aria-checked attribute for screen readers
  keyboard_select(e);
  if (e.keyCode == 13 || e.keyCode == 32) {
    switch (e.target.getAttribute('aria-checked')) {
      case 'true':
        e.target.setAttribute('aria-checked', 'false');
        break;
      case 'false':
        e.target.setAttribute('aria-checked', 'true');
        break;
      default:
        break;
    }
  }
};

// Handle keyboard selection (Enter or Space)
global.keyboard_select = function (e) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    e.target.click();
  }
};

// Handle keyboard selection for scale widgets (tab navigation)
global.scale_select_tab = function (e, name, name_dk, value) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    scale_select(name, name_dk, value);
  }
};

// Select a value in a scale widget
global.scale_select = function (name, name_dk, value) {
  var el, elms;
  el = $('#r-' + name + '-' + value);
  elms = $('.' + name + ' .scale-options .scale_button');
  if (el != null && el.attr('class')) {
    el.removeClass();
    elms.attr('class', 'scale_button scale_cell_value');
    el.addClass('scale_button_high');
    el.addClass('scale_cell_value');
    $('.' + name)
      .find('.scale_button')
      .attr('aria-checked', false);
    el.attr('aria-checked', true);
    el.attr('data-value', value);
  }
  var v = $('input[name=' + name + ']');
  v.val(value);

  // [GRYP-12559] Only attempt to disable a DK checkbox if provided a name.
  if (name_dk) global.disable_dk_check(name_dk);

  // Special handling for 'hidden-response' elements
  // only remove the class (unhide the selected value)
  // for the current scale (not all scales on the page)
  $('tr.' + name)
    .find('div.scale_cell_value')
    .filter('.scale_button_high')
    .removeClass('hidden-response')
    .end();

  // remove any focus states
  elms.find('*').blur();
};

// Disable and uncheck DK (Don't Know) checkbox
global.disable_dk_check = function (name_dk) {
  // If we've provided a 'name' for the DK input, we should
  // use it to target the specific DK input on the page
  // as there could be multiple instances
  var $name = '';
  if (name_dk) {
    $name = '[name="' + name_dk + '"]';
  }
  if ($('.dk-check:visible' + $name).prop('checked')) {
    $('.dk-check:visible' + $name).prop('checked', false);
    $('.dk-check:visible' + $name)
      .closest('.dk-input')
      .find('.uniform-checked')
      .removeClass('uniform-checked');
    if (!name_dk) {
      // Note: this could cause undesirable effects if there
      // are multiple questions on one page with hidden responses
      // because of previously selected DK values
      $('.hidden-response:visible').removeClass('hidden-response');
    }
    $('.hidden-check').removeClass('hidden-check');
  }
};

// Uncheck an array of checkbox elements by ID
global.uncheck_array = function (element_ids) {
  for (var i = 0; i < element_ids.length; i++) {
    var el = $('#' + element_ids[i]);
    if (el && el.is(':checked')) {
      el.prop('checked', false);
      $.uniform.update('#' + element_ids[i]);
    }
  }
};
